<template>
<div class="relationGoods">
    <el-input v-model="serviceName" placeholder="请输入商品名称" style="width: 280px;margin-bottom: 20px" @keyup.enter.native="searchService">
      <i class="el-icon-search el-input__icon" slot="suffix"></i>
    </el-input>
    <el-button class="searchBtn" @click="searchService"></el-button>
    <div class="goodstable">
        <el-table :data="tableData" border max-height="425" class="myRelayionTable" ref="multipleTable" :cell-style="{height:'42px'}" style="width: 100%" :header-cell-style="{background:'#EFF1F5',height:'47px'}" @selection-change="handleSelectionChange">
          <el-table-column type="selection" label="全选" width="100" class-name="checkBoxcom" align="center"></el-table-column>
          <el-table-column align="center" prop="serviceName" label="商品名称"></el-table-column>
          <el-table-column align="center" prop="price" label="建议零售价"></el-table-column>
        </el-table>
        <el-row class="bottomOpt">
            <el-col :span="14">
              <div style="height:20px"></div>
            </el-col>
            <el-col :span="10">
                <span>已选<b>{{chooseLen}}</b>项</span>
                <el-button class="redBtn" @click="confirmAdd">确定选择</el-button>
            </el-col>
        </el-row>
    </div>
</div>
</template>
<script>
import {selectXNStoreServiceList} from '@/api'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}
export default {
  props: ["serverSub", "dialogTableVisible"],
  data() {
    return {
      tableData: [],
      chooseLen: 0,
      myAllselect: [],
      serviceName:'',//体验券商品名称搜索
      servicetabData:this.tabData
    };
  },
  watch:{
    'dialogTableVisible'(val){
      if(val){
        this.searchService();
      }
    }
  },
  created() {
    this.searchService();

  },
  methods: {
    searchService(){
      selectXNStoreServiceList({
          serviceName:this.serviceName,
          serviceType:11,
          storeCode:this.$store.state.userInfo.storeCode
        }).then(res=>{
          this.tableData = res.data;
      });
    },
    handleSelectionChange(val) {
      this.myAllselect = val;
      this.chooseLen = val.length;
    },
    confirmAdd() {
      let arrs = [];
      for(let i of this.myAllselect){
        if(this.serverSub == 6){
          arrs.push({
            storeServiceId:i.id,
            serviceName:i.serviceName,
            price:i.price,
            serviceTimes: 1,
            serviceId:i.serviceId
          });
        }else{
          arrs.push({
            storeServiceId:i.id,
            serviceName:i.serviceName,
            price:i.price,
            serviceTimes: i.serviceTime,
            serviceId:i.serviceId
          });
        }
      }
      this.$refs.multipleTable.clearSelection();
      this.$emit("rowClicks", arrs);
    }
  }
};
</script>

<style lang="less">
.relationGoods {
  width: 100%;
  margin: 0 auto;
  .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
  .el-table td,
  .el-table th {
    padding: 0;
    min-width: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: center;
  }
  .tableGoods {
    .myTitle {
      width: 180px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .bottomOpt {
    margin-top: 15px;
    .checkBoxcom {
      margin-left: 22px;
      b {
        color: #444;
      }
    }
    .el-col-10 {
      text-align: right;
    }
  }
  .checkBoxcom {
    &.noLabel {
      .el-checkbox__label {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/fictionsRelation.vue